import { format, startOfDay, endOfDay } from 'date-fns';
import { FACETS_DATE_PICKER_NAME } from '../constants';
import { DATE_PICKER_CANCEL } from '../mutations/_types';
import { RECORD_CLICK } from '../search/actions/_types';
import { PUSH } from '../../root/actions/_types';

export default ({ minDate, endDate }) =>
  (state, getters, rootState) =>
  ({ [PUSH]: push, [RECORD_CLICK]: recordClick, [DATE_PICKER_CANCEL]: datePickerCancel }) => {
    const {
      search: { facets },
      datePickerCancelled,
    } = state;
    const { 'search/filterExpanded': filterExpanded } = getters;
    const { search: searchParams } = rootState.root;

    const facet = facets.find((f) => f.name === FACETS_DATE_PICKER_NAME) || { items: [] };
    const facetData = facet.items[0];
    const { name: facetName } = facetData || { name: '' };

    /**
     * Update the query string with the selected dates.
     * Date sample that the API accepts: 2020-06-08T00:00:00-05:00
     * @param {string} dateOne Initial selected date in format YYYY-MM-DD
     * @param {string} dateTwo Final selected date in format YYYY-MM-DD
     */
    const updateQuery = (dateOne, dateTwo) => {
      const nextQuery = new URLSearchParams(searchParams);

      nextQuery.delete('promptDatepicker');
      nextQuery.delete('page');

      if (dateOne) {
        // The formatted start of day may be the previous day depending on the user time zone
        // so we need to fix the start of day string
        const dateOneFormat = format(startOfDay(new Date(dateOne)), 'YYYY-MM-DDTHH:mm:ssZ').replace(
          /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
          dateOne,
        );
        nextQuery.set('course.session.start', `${dateOneFormat};d_gte`);
      } else {
        nextQuery.delete('course.session.start');
      }

      if (dateTwo) {
        // The formatted end of day may be the next day depending on the user time zone
        // so we need to fix the end of day string
        const dateTwoFormat = format(endOfDay(new Date(dateTwo)), 'YYYY-MM-DDTHH:mm:ssZ').replace(
          /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
          dateTwo,
        );
        nextQuery.set('course.session.end', `${dateTwoFormat};d_lte`);
      } else {
        nextQuery.delete('course.session.end');
      }

      // Push to history
      push(`?${nextQuery.toString()}`);
    };

    const range = facetName && facetName.split ? facetName.split(',') : '';
    const [dateOne, dateTwo] = range.length === 2 ? range : [];

    return {
      props: {
        minDate,
        endDate,
        dateOne,
        dateTwo,
        startOpen: new URLSearchParams(searchParams).get('promptDatepicker') === 'true',
      },
      classes: [
        {
          'datePicker-hidden': !filterExpanded(FACETS_DATE_PICKER_NAME),
        },
      ],
      on: {
        'date-one-selected': (selectedDate) => {
          if (!selectedDate) return;
          recordClick({
            section: 'facets',
            linkText: `Dates_from:${selectedDate}`,
          });
        },
        'date-two-selected': (selectedDate) => {
          if (!selectedDate) return;
          recordClick({
            section: 'facets',
            linkText: `Dates_to:${selectedDate}`,
          });
        },
        'remove-dates': () => {
          recordClick({
            section: 'remove',
            linkText: `Dates:${facetName}`,
          });
          updateQuery();
        },
        closed(nextOne, nextTwo) {
          if (!nextOne || !nextTwo || datePickerCancelled) return;
          updateQuery(nextOne, nextTwo);
        },
        cancelled() {
          datePickerCancel(true);
        },
        opened() {
          datePickerCancel(false);
        },
      },
    };
  };
